// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { updatePathValidationsDrawer } from 'redux/modules/pathValidationsDrawer'
import initialState from 'redux/modules/pathValidationsDrawer/initialState'

// resets the validation drawer to an empty state.

const removeAllPathValidationsFromDrawer = () => dispatch => (
  dispatch(updatePathValidationsDrawer(initialState))
)

export default removeAllPathValidationsFromDrawer
